import Inspector from './inspector';
import { SelectFAQPosts } from '../__components/select-faq-posts';
import { SelectFAQGroups } from '../__components/select-faq-groups';
import { ServerSideRenderX } from '../__components/server-side-render-x';

const { Component, Fragment } = wp.element;
const { serverSideRender: ServerSideRender } = wp;
const { applyFilters, doAction } = wp.hooks;
const merge = require('deepmerge');
const classnames = require('classnames');

class Edit extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { setAttributes } = this.props;

		//console.log('componentDidMount[box]: EDIT.JS');

		// Compare current block attribute with the default 'box_expand' theme to make sure existing blocks pickup any new style settings added to the plugin. This should work for core and custom themes.
		const merge_attr = merge.all([
			flexible_faqs_editor_data.box_expand.default.faq_attributes,
			this.props.attributes,
		]);

		//console.log('merge_attr: ', merge_attr);
		setAttributes(merge_attr);
	}

	componentDidUpdate(prevProps) {
		//const { attributes: { faqPostId, faqGroupId, faq_group_toggle, faqItems } } = this.props;
		//console.log('componentDidUpdate[box]: EDIT.JS', this.props);
		// Update faq items if toggle has been updated
		//if (prevProps.attributes.faq_group_toggle !== faq_group_toggle) {
		// @TODO we don't need to implement this while using <ServerSideRender /> to render FAQs as they are updated for every change to an attribute. BUT, when we swap back to rendering FAQs in the editor via JS then we WILL need to add this back in. The endpoint may need fixing though as there were issues when the endpoint URL was last tested.
		//updateFaqItems(this.props);
		//}
	}

	render() {
		const {
			attributes: { faq_group_toggle, faqGroupId, faqPostId },
			attributes,
			setAttributes,
			isSelected,
		} = this.props;

		//doAction('add-components', attributes);
		//doAction('test3');

		// add custom attributes
		const custom_attributes = applyFilters(
			'flexible-faqs-custom-attributes',
			{},
			attributes
		);

		return (
			<Fragment>
				{isSelected && (
					<Fragment>
						{faq_group_toggle ? (
							<SelectFAQGroups
								faq_group_toggle={faq_group_toggle}
								faqGroupId={faqGroupId}
								setAttributes={setAttributes}
							/>
						) : (
							<SelectFAQPosts
								faq_group_toggle={faq_group_toggle}
								faqPostId={faqPostId}
								setAttributes={setAttributes}
							/>
						)}
						<hr style={{ margin: '20px 0 15px 0' }} />
					</Fragment>
				)}
				<ServerSideRenderX
					block="flexible-faqs/text-expand-faqs"
					attributes={attributes}
					spinnerLocation={{ right: 0, top: 10, unit: 'px' }}
				/>
				{ /* <ServerSideRender
					block="flexible-faqs/text-expand-faqs"
					attributes={attributes}
				/> */ }
				<Inspector
					attributes={attributes}
					setAttributes={setAttributes}
					blockProps={this.props}
				/>
			</Fragment>
		);
	}
}

export default Edit;
